import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1206_7618",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1206_7618)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.5802 16.25V10.9135H17.9167V16.25H12.5802ZM9.24687 9.08646V3.75H17.9167V9.08646H9.24687ZM2.08333 16.25V10.9135H10.7531V16.25H2.08333ZM2.08333 9.08646V3.75H7.41979V9.08646H2.08333ZM10.4967 7.83667H16.6667V5H10.4967V7.83667ZM3.33333 15H9.50333V12.1633H3.33333V15ZM13.83 15H16.6667V12.1633H13.83V15ZM3.33333 7.83667H6.16999V5H3.33333V7.83667Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDashboard;
